import React, { useEffect } from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

const weeklyReadings = [
  {
    week: "Week 1",
    url: "https://drive.google.com/drive/folders/1DeHcMCj-07lpyvGpYjTELNsQ9FflUcKs",
  },
  {
    week: "Week 2",
    url: "https://drive.google.com/drive/folders/1ZFHOIBh52MJsKVuvlufMBaZIQCvolEWY",
  },
  {
    week: "Week 3",
    url: "https://drive.google.com/drive/folders/1i4epta4taVda_DkRE6VO2xFJxr1PDdvy",
  },
  {
    week: "Week 4",
    url: "https://drive.google.com/drive/folders/12e0TJfqIkbaW_1iZoHcMm1PbdFzbSS9H",
  },
  {
    week: "Week 5",
    url: "https://drive.google.com/drive/folders/1VSEgxQ9gvs2pZ1DGxIsMoa1L4L1MfpSo",
  },
  {
    week: "Week 6",
    url: "https://drive.google.com/drive/folders/1uEw1vVYbcYYKa1xNvm67R_M_NByuR_8A",
  },
];

const WeeklyReadings = () => {
  useEffect(() => {
    document.title =
      "Summer Residency 2026 Workshop Materials - MS Digital Hub";
  }, []);
  return (
    <Box
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 4, md: 6 },
        maxWidth: 1200,
        mx: "auto",
      }}
    >
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 500,
            color: "#111827",
            display: "inline-block",
            borderBottom: "2px solid #FFD700",
            pb: 1,
          }}
        >
          Workshop Materials
        </Typography>

        <Typography
          sx={{
            mt: 2,
            color: "#64748b",
            maxWidth: 620,
            mx: "auto",
            lineHeight: 1.7,
            fontSize: "0.98rem",
            mb: 2,
          }}
        >
          Weekly readings and resources for Summer Residency 2026. Access the
          workshop portal for discussions, activities, and participant
          engagement.{" "}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            flexWrap: "wrap",
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            href="https://www.summerresidency.usmcdh.org/"
            target="_blank"
          >
            Open Workshop Portal
          </Button>

          <Button
            variant="contained"
            href="https://libguides.lib.usm.edu/MS_DH_residency"
            target="_blank"
          >
            Open Research Guide
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          },
          gap: 2.5,
        }}
      >
        {weeklyReadings.map((item, index) => (
          <Card
            key={item.week}
            elevation={0}
            sx={{
              borderRadius: 3,
              border: "1px solid #e5e7eb",
              backgroundColor: "#fff",
              minHeight: 175,
              transition: "all 0.22s ease",
              position: "relative",
              overflow: "hidden",
              "&:before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                height: "4px",
                width: "100%",
                backgroundColor: "#FFD700",
              },
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 14px 28px rgba(15,23,42,.1)",
                borderColor: "#facc15",
              },
            }}
          >
            <CardContent
              sx={{
                p: 3,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: "12px",
                      backgroundColor: "#fff7cc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <MenuBookIcon sx={{ fontSize: 24, color: "#6B4F00" }} />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 900,
                        fontSize: "1.25rem",
                        color: "#111827",
                        lineHeight: 1.1,
                      }}
                    >
                      {item.week}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#64748b",
                        fontSize: "0.85rem",
                        mt: 0.3,
                      }}
                    >
                      Summer Residency 2026
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Button
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                endIcon={<ArrowOutwardIcon />}
                sx={{
                  mt: 2.5,
                  alignSelf: "flex-start",
                  textTransform: "none",
                  fontWeight: 800,
                  color: "#111827",
                  backgroundColor: "#fff7cc",
                  borderRadius: 999,
                  px: 2,
                  py: 0.8,
                  "&:hover": {
                    backgroundColor: "#FFD700",
                  },
                }}
              >
                View Readings
              </Button>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default WeeklyReadings;
